import {
  LoadCoursesAsync,
  MarkCoursesOccupancyAsync,
  MarkMyCoursesAsync,
  ShowMyCartSummaryAsync,
  asyncsleep,
} from './aka.js';
export async function mainkurzy() {
  console.log('LoadCourses');
  await LoadCoursesAsync();
  await asyncsleep(1);
  await MarkCoursesOccupancyAsync();
  await asyncsleep(1);
  await MarkMyCoursesAsync();
  await ShowMyCartSummaryAsync();
}
